










































import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import { Component, Prop, Watch } from "vue-property-decorator";
import { Vue } from "vue-property-decorator";

@Component({
  name: "qMultiSelect",
  components: {
    Multiselect,
  },
})
export default class QMultiSelect extends Vue {
  @Prop({
    default: false,
  })
  public closeOnSelect: boolean;
  @Prop({
    default: false,
  })
  public clearOnSelect: boolean;
  @Prop({
    default: false,
  })
  public showLabels: boolean;

  @Prop({
    default: false,
  })
  public searchable: boolean;

  @Prop({
    default: true,
  })
  public multiple: boolean;

  @Prop({
    default: "すべてのカテゴリ",
  })
  public placeholder: string;

  @Prop({
    required: true,
  })
  public value: any;

  @Prop({
    required: true,
  })
  public options: any;

  @Prop({
    default() {
      return { id: "all", name: "すべて" };
    },
  })
  public allSelected: any;

  public selected: Array<{ id: any; name: string }> = [];

  @Watch("value")
  public changeSelected(): void {
    this.selected = this.options.filter((item) => {
      return (
        this.value.includes(item.id) || this.value.includes(item.id.toString())
      );
    });
  }

  public changeOptions() {
    if (this.selected.length === 0) {
      this.selected = this.allSelected ? [this.allSelected] : [];
    } else if (
      this.selected.some(
        (item) => this.allSelected && item.id === this.allSelected.id,
      ) &&
      this.selected.length > 1
    ) {
      const lastCategory = this.selected[this.selected.length - 1];
      if (this.allSelected && lastCategory.id === this.allSelected.id) {
        this.selected = [this.allSelected];
      } else {
        this.selected = this.selected.filter((item) => {
          return this.allSelected && item.id != this.allSelected.id;
        });
      }
    }
    this.$emit(
      "input",
      this.selected.map((item) => item.id),
    );
  }
  public isCheck(value: any): boolean {
    return this.selected
      ? this.selected.some((status) => value.id == status.id)
      : false;
  }
}
